import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { useHistory, Route, useRouteMatch, useParams } from 'react-router-dom';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
import { MainDialog, SubmitButton } from '../../UI';
import useCheckMobileScreen from '../../../hooks/useWidth';
import { PlusIcon } from '../../UI/Icons';
import PatientProfile from '../../PatientProfile';
import useCheckAccess from '../../../hooks/useCheckAccess';

const styles = makeStyles((theme) => ({
    buttonRoot: (props) => ({
        minWidth: '140px',
        '&:hover': {
            background: ' #1b90fa'
        },
        [theme.breakpoints.down('1025')]: {
            padding: '10px',
            minWidth: '85px'
        },
        [theme.breakpoints.down('414')]: {
            minWidth: !props.rtl && '80px',
            padding: !props.rtl && '5px 0px',
            fontSize: !props.rtl && '10px'
        },
        '& svg': {
            margin: '0 5px'
        }
    })
}));
function AddPatient() {
    const isMobile = useCheckMobileScreen();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const history = useHistory();
    const { url } = useRouteMatch();
    const { clinicId } = useParams();
    const { notEditDemographic } = useCheckAccess();
    const openDialog = () => {
        if (isMobile) {
            history.push(`/${clinicId}/add-patient`);
        } else {
            history.push(`${url}/new`);
        }
    };
    const { messages } = useContext(MessagesContext);
    return (
        <>
            <SubmitButton
                isButton
                mr="0"
                className={classes.buttonRoot}
                handleClick={openDialog}
                data-testid="addPatient"
                disabled={notEditDemographic}
            >
                <PlusIcon width="17px" height="17px" />
                {messages.newPatient}
            </SubmitButton>
            {!notEditDemographic && (
                <Route
                    path={`${url}/new`}
                    render={() => (
                        <MainDialog
                            open={!isMobile && true}
                            title={messages.addNewPatient}
                            goBack={() => {
                                history.goBack();
                            }}
                        >
                            <PatientProfile />
                        </MainDialog>
                    )}
                />
            )}
        </>
    );
}
export default AddPatient;
